import { OverviewTab } from '@/features/events/components/Detail/Tabs/OverviewTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/events/event/$id/overview')({
  component: OverviewTab,
});
